var _defs, _path, _g, _g2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFallback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "corrupted_image_icon",
    "data-name": "corrupted image icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_24",
    "data-name": "Subtraction 24",
    d: "M81,92H11A11,11,0,0,1,0,81V11A11,11,0,0,1,11,0H40.926l-3.82,21.447,9.586,3.238L41.25,49.164l10.1-25.9-6.345-6.6L54.323,0H81A11,11,0,0,1,92,11V81A11,11,0,0,1,81,92Z",
    transform: "translate(0 0)",
    fill: "#3e436b",
    stroke: "#6770b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 81.013,
    height: 81.013,
    rx: 8,
    transform: "translate(0 0)",
    fill: "#6770b3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_25",
    "data-name": "Subtraction 25",
    d: "M81,92H11A11,11,0,0,1,0,81V11A11,11,0,0,1,11,0H40.926l-3.82,21.447,9.586,3.238L41.25,49.164l10.1-25.9-6.345-6.6L54.323,0H81A11,11,0,0,1,92,11V81A11,11,0,0,1,81,92Z",
    transform: "translate(0 0)",
    fill: "#2d314d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_22",
    "data-name": "Mask Group 22",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_21",
    "data-name": "Mask Group 21",
    transform: "translate(5.197 5.198)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_31",
    "data-name": "Union 31",
    d: "M12,90.648a12,12,0,0,1-12-12v-32a12,12,0,0,1,12-12H64.568l-15.779-4.2V12a12,12,0,0,1,12-12h15a12,12,0,0,1,12,12V29c0,4.879-1.327,7.675-4.672,8.81A11.967,11.967,0,0,1,87,46.648v32a12,12,0,0,1-12,12Z",
    transform: "translate(47.34 -2.168) rotate(45)",
    fill: "#6770b3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_26",
    "data-name": "Subtraction 26",
    transform: "translate(0 0)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81,92H11A11,11,0,0,1,0,81V11A11,11,0,0,1,11,0H40.926l-3.82,21.447,9.586,3.238L41.25,49.164l10.1-25.9-6.345-6.6L54.323,0H81A11,11,0,0,1,92,11V81A11,11,0,0,1,81,92Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.00000762939453 89.99980926513672 C 83.40393829345703 89.99980926513672 85.66397857666016 89.06363677978516 87.36377716064453 87.36373901367188 C 89.06364440917969 85.66378021240234 89.99980926513672 83.40343475341797 89.99980926513672 80.99909973144531 L 89.99980926513672 10.99980735778809 C 89.99980926513672 8.595887184143066 89.06365966796875 6.33583402633667 87.36382293701172 4.635980606079102 C 85.66397857666016 2.936154127120972 83.4039306640625 2.000007390975952 81.00000762939453 2.000007390975952 L 55.4957275390625 2.000007390975952 L 47.4769172668457 16.33920097351074 L 52.79532623291016 21.87487411499023 C 53.33523559570312 22.43683433532715 53.49956893920898 23.26122093200684 53.21639251708984 23.98724746704102 L 43.11299514770508 49.89104843139648 C 42.73318099975586 50.86481475830078 41.66762924194336 51.38192749023438 40.66763305664062 51.07772827148438 C 39.66764831542969 50.77352905273438 39.07055282592773 49.75063323974609 39.29735565185547 48.73031234741211 L 44.34890365600586 26.00502967834473 L 36.46512603759766 23.34182167053223 C 35.52763366699219 23.02512741088867 34.96266174316406 22.07046127319336 35.13620758056641 21.09626007080078 L 38.5378532409668 2.000007390975952 L 10.99980735778809 2.000007390975952 C 8.595873832702637 2.000007390975952 6.33582067489624 2.936154127120972 4.635980606079102 4.635980606079102 C 2.936154127120972 6.33582067489624 2.000007390975952 8.595873832702637 2.000007390975952 10.99980735778809 L 2.000007390975952 80.99909973144531 C 2.000007390975952 83.40345001220703 2.936167478561401 85.66378021240234 4.636007308959961 87.36372375488281 C 6.33583402633667 89.06363677978516 8.595873832702637 89.99980926513672 10.99980735778809 89.99980926513672 L 81.00000762939453 89.99980926513672 M 81.00000762939453 91.99980926513672 L 10.99980735778809 91.99980926513672 C 8.061620712280273 91.99980926513672 5.299340724945068 90.85558319091797 3.221767425537109 88.77791595458984 C 1.144180774688721 86.70021057128906 7.484537945856573e-06 83.93763732910156 7.484537945856573e-06 80.99909973144531 L 7.484537945856573e-06 10.99980735778809 C 7.484537945856573e-06 8.061674118041992 1.144180774688721 5.299367427825928 3.221767425537109 3.221767425537109 C 5.299367427825928 1.144180774688721 8.061674118041992 7.484537945856573e-06 10.99980735778809 7.484537945856573e-06 L 40.92559432983398 7.484537945856573e-06 L 37.10520935058594 21.44700813293457 L 46.69110107421875 24.68520736694336 L 41.24970245361328 49.16429901123047 L 51.35309982299805 23.26049995422363 L 45.00810241699219 16.65630149841309 L 54.32268905639648 7.484537945856573e-06 L 81.00000762939453 7.484537945856573e-06 C 83.93814086914062 7.484537945856573e-06 86.70043182373047 1.144180774688721 88.77803039550781 3.221767425537109 C 90.85562133789062 5.299367427825928 91.99980926513672 8.061674118041992 91.99980926513672 10.99980735778809 L 91.99980926513672 80.99909973144531 C 91.99980926513672 83.93763732910156 90.85562133789062 86.70021057128906 88.77803039550781 88.77791595458984 C 86.70047760009766 90.85558319091797 83.93817901611328 91.99980926513672 81.00000762939453 91.99980926513672 Z",
    stroke: "none",
    fill: "#3e436b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(63.064 9.057)",
    fill: "#6770b3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallback);
export default __webpack_public_path__ + "static/media/fallback.fa7c9000.svg";
export { ForwardRef as ReactComponent };